import { createAction, props, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { StatusType } from 'src/app/core/enum/status.enum';
export interface Status {
  type: StatusType;
  isUpdated: boolean;
}
export const updateStatus = createAction(
  '[Status] Update Status',
  props<{ status: Status }>()
);

export const updateStatusReset = (type: StatusType, store) => {
  of(
    { type, isUpdated: true },
    { type: StatusType.Initial, isUpdated: false }
  ).subscribe((status) => {
    store.dispatch(updateStatus({ status }));
  });
  return createAction('empty')();
};
